// @flow

import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.scss';

import { camelCaseToNormalString } from '../../utils/methods';
import type { AttributeType } from '../../api/types';

type Props = {
  attributes: {
    studioPhotos: Array<AttributeType>,
    panorama: Array<AttributeType>,
    campusMap: Array<AttributeType>,
    studioFloorplan: Array<AttributeType>,
  },
  activeTabName: 'studioPhotos' | 'panorama' | 'campusMap' | 'studioFloorplan',
  setActiveTab: (index: number) => void,
  showPDF: () => void,
};

const StudioNav = (props: Props) => (
  <div className={styles.studioNav}>
    <ul>
      {Object.entries(props.attributes).map(
        ([key, value]: [string, mixed], index: number): React.Node => (
          <li
            key={key}
            data-key={key}
            className={classnames(styles.navItem, { [styles.active]: key === props.activeTabName })}
            onClick={() => (key === 'studioFloorplan' ? props.showPDF() : props.setActiveTab(index))}
          >
            <span>/ {camelCaseToNormalString(key)}</span>
          </li>
        ),
      )}
    </ul>
  </div>
);

export default StudioNav;



// WEBPACK FOOTER //
// ./src/components/Studio/Nav.js